export default __webpack_public_path__ + "static/processexplanation-miracl-mobile-69450fff74c40187a2cfc5ffd0d1aea5.svg";